<template>
    <div class="editpage">
        <!-- 面包屑 -->
        <div class="bread">
            <h2>
                <router-link to="/dashboard/template" class="root"><span @click="goIndex">模板管理</span></router-link>
                &nbsp;<i class="el-icon-arrow-right"></i>&nbsp;<span class="curPage">模板配置</span>
            </h2>
            <div class="back" @click="goBack">
                <h3>&lt; 返回上一级</h3>
            </div>
        </div>
        <div class="content">
            <editContent></editContent>
        </div>
    </div>
</template>
<script>
    import bus from '@/assets/js/bus'
    import busType from '@/assets/js/busType'
    import editContent from './editContent'

    import editConf from '@/assets/js/mixin/editConf'

    export default {
        name: 'editpage',
        mixins: [editConf],
        props: {},
        data() {
            return {}
        },
        computed: {},
        components: {
            editContent
        },
        watch: {},
        mounted() {
            // 入口 => edit.js
            let id = this.$route.query.id;
            this.getOcrById(id);

            bus.$on(busType.RESETINDENTITY, (e) => {
                if (e && ['DocFields', 'AddFiedBtn'].indexOf(e) != -1) {
                    //不切换图
                } else {
                    this.$store.dispatch('setCurrentImage', 0);
                }

                this.handleImage(id);
            })
        },
        destroyed() {
            bus.$off(busType.RESETINDENTITY)
            this.$store.dispatch('setCurrentImage', 0);
        },
        methods: {
            handleImage(id, e) {
                this.getOcrById(id);
            },
            goBack() {
                this.$store.dispatch('setEditTemplate', null);

                this.$router.push('/dashboard/template/index');
            },
            goIndex() {
                this.$store.dispatch('setEditTemplate', null);
            }

        }
    };
</script>
<style>
    @import "./editpage.css";
</style>